// test1173
(1173 && 0);
